import { Entity } from '@core/entities/entity'
import { ITaskActivity } from './ITaskActivity'
import { plainToInstance, Type } from 'class-transformer'
import { AuditResult } from '@core/entities/audit/AuditResult'
import { TaskStep } from '@core/entities/task/TaskStep'
import { TaskActivityType } from '@core/entities/task/TaskActivity'
import { Palette } from '@core/theme/color-palette-siteassist'
import { TaskTemplateStepType } from '../TaskTemplateStep'
import { statuses } from '@core/theme/statuses'

export class TaskActivity extends Entity<ITaskActivity> {
  type: TaskActivityType

  date?: string

  @Type(() => AuditResult)
  auditResult?: AuditResult

  @Type(() => TaskStep)
  step?: TaskStep

  public getTitle(): string {
    if (this.type === 'AUDIT_RESULT') {
      if (
        ['TASK_WORK_STEP_SUBMITTED', 'TASK_CREATED', 'TASK_APPROVED'].includes(
          this.auditResult.action,
        )
      ) {
        return (
          this.auditResult?.metadata?.taskPostValuesData?.stepData.name || ''
        )
      }
      return this.auditResult?.getActionLabel() || ''
    } else if (this.type === 'DONE') {
      return statuses.completed.label
    } else {
      return this.step?.name || ''
    }
  }

  public getAuditActionStepType(): TaskTemplateStepType | null {
    switch (this.auditResult?.action) {
      case 'TASK_CHANGES_REQUESTED':
        return 'APPROVAL'
      case 'TASK_WORK_STEP_SUBMITTED':
        return 'WORK'
      case 'TASK_CREATED':
        return 'CREATION'
      case 'TASK_APPROVED':
        return 'APPROVAL'
      default:
        return null
    }
  }

  public getStepTypeColor(type?: TaskTemplateStepType | 'DONE'): string {
    const stepType = type || this.step?.type
    switch (stepType) {
      case 'CREATION':
        return Palette.LightBlue.A400
      case 'WORK':
        return Palette.Green[500]
      case 'APPROVAL':
        return Palette.Amber[600]
      case 'DONE':
        return Palette.Blue[500]
      default:
        return Palette.BlueGrey[500]
    }
  }

  public static new(payload: unknown): TaskActivity {
    const entity = plainToInstance(TaskActivity, payload)

    return entity
  }
}
